import { FC } from 'react';

export const Clock: FC = () => (
  <svg viewBox="0 0 512 512" fill="currentColor">
    <path d="M256 16C123.5 16 16 123.5 16 256s107.5 240 240 240 240-107.5 240-240S388.5 16 256 16zm0 448c-115.8 0-208-92.2-208-208S140.2 48 256 48s208 92.2 208 208-92.2 208-208 208z" />
    <path d="M280 128h-16a16 16 0 0 0-16 16v112.6l-64.4 64.4a16 16 0 1 0 22.6 22.6l68.8-68.8A16 16 0 0 0 280 272V144a16 16 0 0 0-16-16z" />
  </svg>
);

export default Clock;
